module.exports = __webpack_public_path__ + "img/img2.e71824d2.png";